"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertIsComponent = exports.isComponent = void 0;
const utils_1 = require("@metamask/utils");
const superstruct_1 = require("superstruct");
const nodes_1 = require("./nodes");
/**
 * Check if the given value is a {@link Component}. This performs recursive
 * validation of the component's children (if any).
 *
 * @param value - The value to check.
 * @returns `true` if the value is a {@link Component}, `false` otherwise.
 */
function isComponent(value) {
    return (0, superstruct_1.is)(value, nodes_1.ComponentStruct);
}
exports.isComponent = isComponent;
/**
 * Assert that the given value is a {@link Component}. This performs recursive
 * validation of the component's children (if any).
 *
 * @param value - The value to check.
 * @throws If the value is not a {@link Component}.
 */
function assertIsComponent(value) {
    (0, utils_1.assertStruct)(value, nodes_1.ComponentStruct, 'Invalid component');
}
exports.assertIsComponent = assertIsComponent;
//# sourceMappingURL=validation.js.map